import {OETarget} from '../../../react-oe/oe-target';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEVersionFeatureAccess, OEVersionTargetsAlphaBetaProds, OEVersionStartSelectionDataAlphaBetaProd} from '../oe-proto-model';
import {OESurgeryTargetType as OESurgeryTargetType_, OESurgeryStartSelectionContent} from './oe-surgery-consts';

export const OESurgeryTargetType = OESurgeryTargetType_;

export const OESurgeryTargets = new OEVersionTargetsAlphaBetaProds(
    {
        [OESurgeryTargetType.orthoOp]: [
            OETarget.surgeryIdo,
            OETarget.surgeryOHSTPrimaCurve,
        ],
        [OESurgeryTargetType.ophthalmology]: [
            OETarget.surgeryEyeCataract,
        ],
        [OESurgeryTargetType.approachOp]: [
            OETarget.implantcastHipDorsalApproach,
        ],
        [OESurgeryTargetType.anatomy]: [
            OETarget.humanEye2,
            OETarget.humanHead,
            OETarget.humanLarynx,
            OETarget.humanSkull,
            OETarget.humanCranialNerves,
            OETarget.humanArm,
            OETarget.humanShoulderGirdle,
            OETarget.humanUpperArmElbow,
            OETarget.humanForearm,
            OETarget.humanHand,
            OETarget.humanLeg,
            OETarget.humanThighKnee,
            OETarget.humanAnkleFoot,
            OETarget.humanHip2,
            OETarget.humanLowerLeg,
            OETarget.humanTrunk,
            OETarget.humanTrunkVessel,
            OETarget.humanPelvis,
            OETarget.humanSpine,
            OETarget.humanNeckBack,
            OETarget.humanAbdominalWall,
            OETarget.humanChestWall
        ]
    },
    {
        [OESurgeryTargetType.orthoOp]: OETarget.surgeryIdo,
        [OESurgeryTargetType.ophthalmology]: OETarget.surgeryEyeCataract,
        [OESurgeryTargetType.approachOp]: OETarget.implantcastHipDorsalApproach,
        [OESurgeryTargetType.anatomy]: OETarget.humanHip2,
    },
    {
        [OESurgeryTargetType.orthoOp]: OETarget.surgeryIdo,
        [OESurgeryTargetType.ophthalmology]: OETarget.surgeryEyeCataract,
        [OESurgeryTargetType.approachOp]: OETarget.implantcastHipDorsalApproach,
        [OESurgeryTargetType.anatomy]: OETarget.humanHip2,
    }
);

//
export const OESurgeryLicensingEdition = {
    IDO:            'IDO'
};

export const OESurgeryFeatureAccess = new(class extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        return Object.assign(this.createFeatureAccessObj(), {
            anatomyTargetSelection: !isLicensing,
            approachOpModule: !isLicensing,
            approachOpTargetSelection: !isLicensing,
            ophthalmologyTargetSelection: !isLicensing,
            orthoOpTargetSelection: !isLicensing,
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.createFeatureAccessObj();

        let featureAccess = this.initialFeatureAccess();

        if(!licensingAccess.isValid)    return featureAccess;

        if([OELicensingEdition.basic].includes(licensingAccess.edition))  {
            featureAccess.anatomyTargetSelection = true;

            featureAccess.approachOpModule = true;
            featureAccess.approachOpTargetSelection = true;

            featureAccess.ophthalmologyTargetSelection = true;

            featureAccess.orthoOpTargetSelection = true;
        }

        if([OELicensingEdition.viewer, OELicensingEdition.singleUser].includes(licensingAccess.edition))  {
            featureAccess.anatomyTargetSelection = true;

            featureAccess.approachOpModule = true;
            featureAccess.approachOpTargetSelection = true;

            featureAccess.ophthalmologyTargetSelection = true;

            featureAccess.orthoOpTargetSelection = true;
        }

        if(OELicensingEdition.allAbove(OELicensingEdition.extended).includes(licensingAccess.edition))  {
            featureAccess.anatomyTargetSelection = true;

            featureAccess.approachOpModule = true;
            featureAccess.approachOpTargetSelection = true;

            featureAccess.ophthalmologyTargetSelection = true;

            featureAccess.orthoOpTargetSelection = true;
        }

        if([OESurgeryLicensingEdition.IDO].includes(licensingAccess.edition))  {
            featureAccess.anatomyTargetSelection = true;

            featureAccess.approachOpModule = false;
            featureAccess.approachOpTargetSelection = false;

            featureAccess.ophthalmologyTargetSelection = true;

            featureAccess.orthoOpTargetSelection = true;
        }

        return featureAccess;
    }
})(OESurgeryTargets);

//
export const OESurgeryStartSelectionData = new OEVersionStartSelectionDataAlphaBetaProd(
    OESurgeryTargets,
    OESurgeryStartSelectionContent
);